module.exports = __webpack_public_path__ + "img/pc.c3b3f9bd.png";